export default "__VITE_ASSET__w_nrwsoy__"